import React from 'react';
import { Card, message, Button, Form, Input } from 'antd';
import QueueAnim from 'rc-queue-anim';
import axios from '../../axios/index';

import 'braft-editor/dist/index.css';
import 'braft-extensions/dist/code-highlighter.css';
import BraftEditor from 'braft-editor';
import CodeHighlighter from 'braft-extensions/dist/code-highlighter';
import 'prismjs/components/prism-java';
import 'prismjs/components/prism-csharp';
import 'prismjs/components/prism-php';

const options = {
    syntaxs: [
        {
            name: 'JavaScript',
            syntax: 'javascript'
        }, {
            name: 'HTML',
            syntax: 'html'
        }, {
            name: 'CSS',
            syntax: 'css'
        }, {
            name: 'C#',
            syntax: 'csharp',
        }, {
            name: 'java',
            syntax: 'java',
        }, {
            name: 'php',
            syntax: 'php',
        }
    ]
}

BraftEditor.use(CodeHighlighter({
  includeEditors: ['ecodehighlighter'],
}))
BraftEditor.use(CodeHighlighter(options))
const FormItem = Form.Item;
class ArtEdit extends React.Component {
    state = {
        show: false,
        artical: []
    }
    params = {
        page: 1
    }
    componentDidMount() {
        this.props.form.setFieldsValue({
            content: BraftEditor.createEditorState('')
        })
    }

    handleSubmit = (event) => {

        event.preventDefault()

        this.props.form.validateFields((error, values) => {
            if (!error) {
                const submitData = {
                    title: values.title,
                    content: values.content.toRAW() // or values.content.toHTML()
                }
                console.log(submitData)
            }
        })

    }
    render() {
        const { getFieldDecorator } = this.props.form;
        const controls = ['bold', 'italic', 'underline', 'text-color', 'separator', 'link', 'separator', 'media', 'code']

        return (
            <div>
                <Form onSubmit={this.handleSubmit}>
                    <FormItem>
                        {getFieldDecorator('title', {
                            rules: [{
                                required: true,
                                message: '请输入标题',
                            }],
                        })(
                            <Input size="large" placeholder="请输入标题" />
                        )}
                    </FormItem>
                    <FormItem>
                        {getFieldDecorator('content', {
                            validateTrigger: 'onBlur',
                            rules: [{
                                required: true,
                                validator: (_, value, callback) => {
                                    if (value.isEmpty()) {
                                        callback('请输入正文内容')
                                    } else {
                                        callback()
                                    }
                                }
                            }],
                        })(
                            <BraftEditor
                                id="ecodehighlighter"
                                className="my-editor"
                                // controls={controls}
                                placeholder="请输入正文内容"
                            />
                        )}
                    </FormItem>
                    <FormItem >
                        <Button size="large" type="primary" htmlType="submit">提交</Button>
                    </FormItem>
                </Form>
            </div>
        );
    }
}

export default Form.create()(ArtEdit);